<template>
  <j-modal
    :title="language['PlatForm.employee.chooseDepart']"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    wrapClassName="j-depart-select-modal"
    switchFullscreen
    :cancelText="language['common.closeButton']">
    <a-tabs @change="changeTabs" :default-active-key="currentApplicationId" size="large" v-if="applications.length>0" style="margin-bottom: 20px;">
      <a-tab-pane loading="true" :tab="item.applicationNameLanguage||item.applicationName"  v-for="(item,index) in applications" :key="item.id">
        <a-spin tip="Loading..." :spinning="false">
        <!--<a-input-search style="margin-bottom: 1px" placeholder="请输入部门名称按回车进行搜索" @search="onSearch" />-->
          <a-tree
            checkable
            :multiple="multi"
            :class="treeScreenClass"
            @check="onCheck"
            :checkStrictly="checkStrictly"
            :checkedKeys="checkedKeys"
            :treeData="treeData"
            :expandedKeys="iExpandedKeys"
            :autoExpandParent="autoExpandParent"
            @expand="onExpand"
          />
          <!--:expandedKeys="iExpandedKeys"-->
        </a-spin>
      </a-tab-pane>


    </a-tabs>
    <div v-else style="margin-bottom: 20px;">{{language['NoApplication']}}</div>

    <!--</a-spin>-->
    <!--底部父子关联操作和确认取消按钮-->
    <template slot="footer" >
      <div class="drawer-bootom-button">
        <a-dropdown style="float: left" :trigger="['click']" placement="topCenter" v-if="treeOpera && multi">
          <a-menu slot="overlay">
            <!--<a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联111</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>-->
            <a-menu-item key="5" @click="expandAll">{{language['sweep_expenseall']}}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{language['sweep_collegeall']}}</a-menu-item>
          </a-menu>
          <a-button>
            {{language['sweep_treeoperate']}} <a-icon type="up" />
          </a-button>
        </a-dropdown>
        <a-button @click="handleCancel" type="primary" style="margin-right: 0.8rem">{{language['common.closeButton']}}</a-button>
        <a-button @click="handleSubmit" type="primary" >{{language['common.confirmButton']}}</a-button>
      </div>
    </template>
  </j-modal>
</template>

<script>
  import { queryDepartTreeList } from '@/api/api'
  import { getAction,putAction,postAction } from '@/api/manage'
  export default {
    name: 'JSelectDepartModalByApplication',
    /*props:['modalWidth','multi','rootOpened','departId', 'store', 'text','treeOpera'],*/
    props:{
      modalWidth:Number,
      // multi:Boolean,
      rootOpened:Boolean,
      departId:String,
      store:String,
      text:String,
      treeOpera:{
        default:true,
        type:Boolean
      },
      multi:{
        default:true,
        type:Boolean
      },
    },
    data(){
      return {
        visible:false,
        confirmLoading:false,
        treeData:[],
        autoExpandParent:true,
        expandedKeys:[],
        dataList:[],
        checkedKeys:[],
        checkedRows:[],
        searchValue:"",
        checkStrictly: true,
        fullscreen:false,
        iExpandedKeys:[],

        applications:[],
        currentApplicationId:"",
        currentApplicationName:"",
        checkedWithApplication:[],
        defaultData:[],
        map:{},
      }
    },
    created(){
        // this.loadDepart();
    },
    watch:{
      /*departId(){
        this.initDepartComponent()
      },
      visible: {
        handler() {
          this.initDepartComponent(true)
        }
      },*/
    },
    computed:{
      treeScreenClass() {
        return {
          'my-dept-select-tree': true,
          'fullscreen': this.fullscreen,
        }
      },
      language() {
        return this.$store.getters.language
      },
      /*applications(){
        this.currentApplicationId = "1";
      },*/
    },
    methods:{
      changeTabs(activeKey){
        this.checkedKeys = [];
        this.currentApplicationId = activeKey
        this.loadDepart(this.getApplicationCode(activeKey))
        for(let i=0;i<this.checkedWithApplication.length;i++){
          let item = this.checkedWithApplication[i];
          if(item.applicationId == this.currentApplicationId){
            for(let j=0;j<item.selectedDeparts.length;j++){
              this.checkedKeys.push(item.selectedDeparts[j])
            }
          }
        }
        // this.iExpandedKeys = this.checkedKeys;
      },
      getApplicationCode(activeKey){
        // return this.applications[index].applicationCode
        let applicationCode = "";
        this.applications.forEach(item=>{
          if(item.id==activeKey){
            applicationCode = item.applicationCode;
          }
        })
        return applicationCode;
      },
      show(applications,checkedWithApplication){
        this.visible=true
        this.applications = applications;
        console.log('--applications=====',applications);
        if(applications&&applications.length>0){
          this.currentApplicationId = applications[0].id;
          console.log('--appid=====',applications[0].id + '===' + applications[0].applicationCode);
          this.loadDepart(applications[0].applicationCode)
          this.checkedWithApplication = checkedWithApplication;
          // this.defaultData = [...checkedWithApplication];
          let array = [];
          for(let i=0;i<checkedWithApplication.length;i++){
            let item = checkedWithApplication[i];
            if(item.applicationId == this.currentApplicationId){
              for(let j=0;j<item.selectedDeparts.length;j++){
                this.checkedKeys.push(item.selectedDeparts[j]);
              }
            }
           array.push({...item});
          }
          this.defaultData = array
          // this.iExpandedKeys = this.checkedKeys;
        }

      },
      expandAll () {
        /*let datalist = this.getCheckedRows(this.checkedKeys);
        this.iExpandedKeys = datalist;*/
        // this.iExpandedKeys = this.checkedKeys;
        // let datalist = this.getCheckedRows(this.checkedKeys);
        this.iExpandedKeys = this.dataList;
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      onExpand(expandedKeys) {
        // console.log('onExpand', expandedKeys)
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      loadDepart(applicationCode){
        if(!applicationCode){
          return;
        }
        // 这个方法是找到应用的所有部门信息
        queryDepartTreeList({"applicationCode":applicationCode}).then(res=>{
          console.log('---dep--res--',res);
          if(res.success){
            let arr = [...res.result]
            this.treeData = arr
            for(let item of arr){
              this.setThisExpandedKeys(item)
            }
          }
        })
      },
      setThisExpandedKeys(node) {
          if (node.children && node.children.length > 0) {
            this.dataList.push(node.key)
            for (let a = 0; a < node.children.length; a++) {
              this.setThisExpandedKeys(node.children[a])
            }
          }
      },


      onCheck (checkedKeys,info) {
        let that = this;
        let boo = true;
        for(let i=0;i<that.checkedWithApplication.length;i++){
          // let map = [...that.checkedWithApplication[i]];
          if(that.checkedWithApplication[i].applicationId==that.currentApplicationId){
            if(!that.multi){
              let arr = checkedKeys.checked.filter(item => that.checkedKeys.indexOf(item) < 0)
              that.checkedWithApplication[i].selectedDeparts = [...arr];
              let datalist = this.getCheckedRows(that.checkedWithApplication[i].selectedDeparts);
              let selectedDepartNames = ""
              for(let j=0;j<datalist.length;j++){
                if(selectedDepartNames == ""){
                  selectedDepartNames = datalist[j].title;
                }else{
                // &nbsp;
                  selectedDepartNames = selectedDepartNames+"\u00A0 |\u00A0 "+datalist[j].title;
                }
              }
              that.checkedWithApplication[i].selectedDepartNames = selectedDepartNames;
              that.checkedKeys = [...arr];
            }else{
              if(that.checkStrictly){
                that.checkedWithApplication[i].selectedDeparts = checkedKeys.checked
                let datalist = this.getCheckedRows(that.checkedWithApplication[i].selectedDeparts);
                let selectedDepartNames = ""
                for(let j=0;j<datalist.length;j++){
                  if(selectedDepartNames == ""){
                    selectedDepartNames = datalist[j].title;
                  }else{
                    selectedDepartNames = selectedDepartNames+"\u00A0 |\u00A0 "+datalist[j].title;
                  }
                }

                that.checkedWithApplication[i].selectedDepartNames = selectedDepartNames;
                that.checkedKeys = checkedKeys.checked
              }else{
                that.checkedKeys = checkedKeys
                that.checkedWithApplication[i].selectedDeparts = checkedKeys

                let datalist = this.getCheckedRows(that.checkedWithApplication[i].selectedDeparts);
                let selectedDepartNames = ""
                for(let j=0;j<datalist.length;j++){
                  if(selectedDepartNames == ""){
                    selectedDepartNames = datalist[j].title;
                  }else{
                    selectedDepartNames = selectedDepartNames+"\u00A0 |\u00A0 "+datalist[j].title;
                  }
                }
                that.checkedWithApplication[i].selectedDepartNames = selectedDepartNames ;
                /*for(let i=0;i<that.checkedWithApplication[i].selectedDeparts.length;i++){
                  let departId = that.checkedWithApplication[i].selectedDeparts;

                  getAction("/sys/sysDepart/queryIds",{ids:departId.join(",")}).then(res=>{
                    if(res.success){
                      let selectedDepartNames = "";
                      res.result.forEach(item=>{
                        if(selectedDepartNames == ""){
                          selectedDepartNames = item.departName;
                        }else{
                          selectedDepartNames = selectedDepartNames+" | "+item.departName;
                        }
                      })
                      that.checkedWithApplication[i].selectedDepartNames = selectedDepartNames ;
                    }
                  })


                }*/
              }
            }
            boo = false;
          }
        }
        if(boo){
          let newmap = {};
          newmap.applicationId = this.currentApplicationId;
          this.applications.forEach(item=>{
            if(item.id==this.currentApplicationId){
              newmap.applicationName = item.applicationName;
            }
          })
          if(!that.multi){
            let arr = checkedKeys.checked.filter(item => that.checkedKeys.indexOf(item) < 0)
            newmap.selectedDeparts = [...arr];

            let datalist = this.getCheckedRows(newmap.selectedDeparts);
            let selectedDepartNames = ""
            for(let j=0;j<datalist.length;j++){
              if(selectedDepartNames == ""){
                selectedDepartNames = datalist[j].title;
              }else{
                selectedDepartNames = selectedDepartNames+"\u00A0 |\u00A0 "+datalist[j].title;
              }
            }
            newmap.selectedDepartNames = selectedDepartNames ;

            this.checkedKeys = [...arr];
          }else{
            if(that.checkStrictly){
              newmap.selectedDeparts = checkedKeys.checked

              let datalist = this.getCheckedRows(newmap.selectedDeparts);
              let selectedDepartNames = ""
              for(let j=0;j<datalist.length;j++){
                if(selectedDepartNames == ""){
                  selectedDepartNames = datalist[j].title;
                }else{
                  selectedDepartNames = selectedDepartNames+"\u00A0 |\u00A0 "+datalist[j].title;
                }
              }
              newmap.selectedDepartNames = selectedDepartNames ;

              that.checkedKeys = checkedKeys.checked
            }else{
              newmap.selectedDeparts = checkedKeys
              let datalist = this.getCheckedRows(newmap.selectedDeparts);
              let selectedDepartNames = ""
              for(let j=0;j<datalist.length;j++){
                if(selectedDepartNames == ""){
                  selectedDepartNames = datalist[j].title;
                }else{
                  selectedDepartNames = selectedDepartNames+"\u00A0 |\u00A0 "+datalist[j].title;
                }
              }
              newmap.selectedDepartNames = selectedDepartNames ;
              that.checkedKeys = checkedKeys.checked
            }
          }
          that.checkedWithApplication.push(newmap);
        }
      },

      // onExpand (expandedKeys) {
      //   this.expandedKeys = expandedKeys
      //   this.autoExpandParent = false
      // },
      handleSubmit(){
        let data = this.checkedWithApplication;
        this.$emit("ok", data)
        this.handleClear()
      },
      handleCancel(){
        this.$emit("ok", this.defaultData);
        this.handleClear()
      },
      handleClear(){
        this.checkedKeys=[]
        this.checkedWithApplication = [];
        this.defaultData = [];
        this.visible=false
      },
      // 根据 checkedKeys 获取 rows
      getCheckedRows(checkedKeys) {
        const forChildren = (list, key) => {
          for (let item of list) {
            if (item.id === key) {
              return item
            }
            if (item.children instanceof Array) {
              let value = forChildren(item.children, key)
              if (value != null) {
                return value
              }
            }
          }
          return null
        }

        let rows = []
        for (let key of checkedKeys) {
          let row = forChildren(this.treeData, key)
          if (row != null) {
            rows.push(row)
          }
        }
        return rows
      },
      getParentKey(currKey,treeData){
        let parentKey
        for (let i = 0; i < treeData.length; i++) {
          const node = treeData[i]
          if (node.children) {
            if (node.children.some(item => item.key === currKey)) {
              parentKey = node.key
            } else if (this.getParentKey(currKey, node.children)) {
              parentKey = this.getParentKey(currKey, node.children)
            }
          }
        }
        return parentKey
      },
      onSearch(value){
        const expandedKeys = this.dataList.map((item) => {
          if (item.title.indexOf(value) > -1) {
            return this.getParentKey(item.key,this.treeData)
          }
          return null
        }).filter((item, i, self) => item && self.indexOf(item) === i)

        Object.assign(this, {
          expandedKeys,
          searchValue: value,
          autoExpandParent: true,
        })


      },


    }
  }

</script>

<style lang="less" scoped>
  // 限制部门选择树高度，避免部门太多时点击确定不便
  .my-dept-select-tree{
    height:350px;
    
    &.fullscreen{
      height: calc(100vh - 250px);
    }
    overflow-y: scroll;
  }
  .drawer-bootom-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>